import $ from 'jquery';

export const PXGaTracking = (function() {
	'use strict';

	var eventData;

	function init() {
		events();
	}

	function events() {

		$('a[data-category]').click( function(){
			var $t = $(this),
					cat = $t.data('category'),
					label = $t.data('label'),
					url = $t.attr('href');

			gaClickHandler(url, cat, label);
		});
	}

	function gaClickHandler(url, cat, label){

		if (gtag) {
			gtag('event', 'click', {
				'event_category': cat,
				'event_label': label,
				'value': url
			});
		}

		console.warn(
			'Sent a GA event: ', "\n",
			'Category: ' + cat, "\n",
			'Label: ' + label, "\n",
			'Value: ' + url
		);
	}

	return {
		init:init
	};
}());
